import { usePrenuvoStore } from '@/stores/usePrenuvoStore';
import {
  isResearchOnlyLocation,
  replaceLocationBasedTerms,
} from '@/utils/replaceLocationBasedTerms';
import { Typography } from '@prenuvo/halo-web';
import { useShallow } from 'zustand/react/shallow';
import { CheckMarkIcon } from '.';

export const ConfirmationHeader = () => {
  const { email, locationId } = usePrenuvoStore(
    useShallow((state) => ({
      email: state.user.email,
      locationId: state.scan.locationId,
    })),
  );

  return (
    <div>
      <CheckMarkIcon />
      <Typography variant="h4" as="h4" className="my-4">
        {/* TODO: In this text because of grammar we can't use the replaceLocationBasedTerms function */}
        {isResearchOnlyLocation(locationId)
          ? 'You have been successfully enrolled!'
          : `Your scan has been ${replaceLocationBasedTerms('booked', locationId)}!`}
      </Typography>
      <Typography variant="paragraph-md" as="p" className="break-words">
        Your {replaceLocationBasedTerms('appointment', locationId)} is confirmed and receipt has
        been sent to {email}
      </Typography>
      <Typography variant="paragraph-md" as="p">
        Feel free to call us at{' '}
        <a href="tel:+18337736886" className="text-green-700 underline">
          (+1) 833 773 6886
        </a>{' '}
        if you have any questions regarding your{' '}
        {replaceLocationBasedTerms('appointment', locationId)}.
      </Typography>
    </div>
  );
};
